import React, { useEffect } from "react";
import { TicketPage } from "../Ticket/TicketPage";
import { useParams } from "react-router-dom";
import { ChatApi } from "../../redux/api/ChatApi";
import { SetDescription, SetEndUser, SetEndUserUid, SetEndUserName } from '../../slices/TicketSlice'
import { SetAction } from '../../slices/ActionSlice'
import { useReduxDispatch } from "../../redux/hooks";
import { UserApi } from "../../redux/api/UserApi";
import { IAction } from "../../types/Action/IAction";
import './LogTicketStyle.scss'

const LogTicketFromChat: React.FunctionComponent<any> = props => {
    const { chatUid } = useParams();
    const dispatch = useReduxDispatch();
    const { data: chat } = ChatApi.useGetChatQuery(chatUid, { skip: !chatUid });
    const { data: messages } = ChatApi.useGetMessagesQuery(chatUid, { skip: !chatUid });
    const { data: endUser } = UserApi.useGetUserQuery(chat?.EndUser_Uid, { skip: !chat?.EndUser_Uid });

    useEffect(() => {
        if (chat && endUser && messages) {
            //The ticket decswription should be the first messages from the end user until the agent responds
            const firstMessages = [];
            for (var i = 0; i < messages.length; i++) {
                if (i === 0 || messages[i].Contact_Id === messages[0].Contact_Id) {
                    firstMessages.push(messages[i]);
                } else {
                    break;
                }
            }
            const ticketDescription = firstMessages?.map((m, i) => m.Text).join('\n');

            const actionNotes = '<div class="chat-window"><div class="messages">' + messages?.map((m, i) => {
                if (firstMessages.map(f => f.Id).indexOf(m.Id) < 0) { }
                const style = m.Is_Event ? 'event' : m.Contact_Id === chat.StaffContact_Id ? 'them' : 'me';

                return `<div class="${style}">${m.Profile_Image ? '<img class="profile" src="' + m.Profile_Image + '" />' : ''}
                        <div class="wrap"><span class="time-stamp">${new Date(m.Created).toLocaleString()}</span>  -<span class="message-from">${m.From ?? ''}</span><span class="message-text">${m.Text}</div>
                        </div>`;
            }).join('').replaceAll('\n', '') + '</div></div>';


            console.log('actionNotes', actionNotes);

            ticketDescription && dispatch(SetDescription(ticketDescription));
            dispatch(SetEndUserUid(chat?.EndUser_Uid));
            dispatch(SetEndUserName(endUser.FullName));
            dispatch(SetEndUser(endUser));
            dispatch(SetAction({ HTML_Notes: actionNotes } as IAction));
        }

    }, [chat, endUser]);

    return (
        <>
            <TicketPage isModal={true} >
            </TicketPage>
        </>
    );
}

export default LogTicketFromChat;